import { articles } from "@/mocks/gossipData";
import ArticleCard from "@/components/feature/ArticleCard";

interface RelatedArticlesProps {
  currentId: string;
  categorySlug: string;
}

export default function RelatedArticles({ currentId, categorySlug }: RelatedArticlesProps) {
  const sameCategory = articles.filter(
    (item) => item.id !== currentId && item.categorySlug === categorySlug,
  );
  const others = articles.filter(
    (item) => item.id !== currentId && item.categorySlug !== categorySlug,
  );
  const related = sameCategory.concat(others).slice(0, 3);

  if (related.length === 0) {
    return null;
  }

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20" aria-label="相关推荐">
      <div className="flex flex-col gap-3">
        <span className="text-xs font-label uppercase tracking-widest text-primary-600">
          Related
        </span>
        <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">继续吃瓜</h2>
        <p className="max-w-2xl text-sm text-foreground-600">
          根据本篇的主题与分类，为你挑了几篇同样值得一看的合集。
        </p>
      </div>
      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {related.map((item) => (
          <ArticleCard key={item.id} article={item} />
        ))}
      </div>
    </section>
  );
}